import React from 'react'
import { TTrainerHorse } from '../../shared/types/trainerHorse.type'
import { Avatar, Box, Card, Chip, IconButton, Switch, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import dayjs from 'dayjs'
import { Edit, Warning } from '@mui/icons-material'
import { upperCase } from 'lodash'
import { routes } from '../../pages/routes'
import { Link } from 'react-router-dom'

function HorseCard({ horse, onChange, onEdit }: { horse: TTrainerHorse, onChange: (id: number, checked: boolean) => void, onEdit: (horse: TTrainerHorse) => void }) {

    const getYear = (date?: string): string | number => {
        if (!date) return ' - '
        return dayjs(date).year()
    }

    return (
        <Link to={routes.DASHBOARD_ROUTES.HORSE_VIEW.replace(':id', String(horse?.horse?.id))} style={{textDecoration:'none'}}>
            <Card sx={{ p: 2, borderRadius: 3, position: 'relative', opacity: !horse.horse_in_training ? 0.6 : 1 }} elevation={2}>

                <Box display={'flex'} gap={2}>
                    <Avatar sx={{ width: 62, height: 62 }} src={horse.horse.avatar_url}></Avatar>
                    <Box display={'flex'} flexDirection={'column'} flex={1} justifyContent={'space-between'}>
                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} flexWrap={'wrap'}>
                            <Typography variant='subtitle1' fontWeight={500}>{(horse?.horse?.name ?? '-').toUpperCase()}</Typography>
                            <Box>
                                {horse.trainer &&
                                    <Tooltip arrow placement='top' title={horse.horse_in_training ? t('horse:markOutOfTraining') : t('horse:markInTraining')}>
                                        <Switch
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => {
                                                onChange(horse.id, e.target.checked)
                                            }} size='small' sx={{ zIndex: 10 }} checked={horse.horse_in_training}></Switch>
                                    </Tooltip>
                                }
                                {horse.horse.editable && <IconButton onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    onEdit(horse)
                                }
                                } size='small'><Edit sx={{ width: 18, height: 18 }}></Edit></IconButton>}

                            </Box>
                        </Box>
                        <Box display={'flex'} flexWrap={'wrap'} justifyContent={'space-between'} alignItems={'center'}>
                            <Box display={'flex'} gap={2} flexWrap={'wrap'}>
                                <Typography sx={{ display: 'flex', alignItems: 'center' }} fontWeight={500} variant='caption'>{t('gender')} :&#8200; <Typography variant='caption'> {horse?.horse?.gender ? t(`genders:byKey:${horse.horse?.gender}`) : '-'}</Typography></Typography>
                                <Typography sx={{ display: 'flex', alignItems: 'center' }} fontWeight={500} variant='caption'>{t('year')} :&#8200; <Typography variant='caption'> {getYear(horse?.horse?.birthday)}</Typography></Typography>
                                <Typography sx={{ display: 'flex', alignItems: 'center' }} fontWeight={500} variant='caption'>{t('breed:breed')} :&#8200; <Typography variant='caption'> {typeof horse?.horse?.breed !== 'string' && horse?.horse?.breed?.ifce_code ? t(`breed:${horse.horse?.breed?.ifce_code}`) : '-'}</Typography></Typography>
                            </Box>
                            {!horse.horse_in_training && <Chip color='warning' variant='outlined' label={t('trainingStatus:0')} size='small'></Chip>}
                        </Box>
                    </Box>
                </Box>
            </Card>
        </Link>
    )
}

export default HorseCard